var $ = require("./lib/qsa");
var pym = require("./lib/pym");
var ANALYTICS = require("./lib/analytics");
require("./lib/webfonts");
var { isMobile } = require("./lib/breakpoints");
var { classify } = require("./lib/helpers");

var filters = $.one("#filters");
var filterStatus = $.one("#filterStatus");
var reviews = $("#reviews .review");
var pymChild = null;
var usedFilters = false;

// Type filter tracking
var typeMode = "all"; // can be "all", "film", or "tv"

var onWindowLoaded = function() {
  pym.then(child => {
    pymChild = child;

    // shuffle programs
    shufflePrograms("reviews", "review");

    filters.addEventListener("input", filterContent);

    // check filters from parent URL
    var parentUrl = new URL(pymChild.parentUrl, location, true);
    var params = new URLSearchParams(parentUrl.search);
    var presetGenre = params.get("genre");
    var presetPlatform = params.get("platform");

    if (presetGenre) {
      var selector = $.one("#filters #genre_" + presetGenre);
      if (selector) {
        selector.click();
      }
    }

    if (presetPlatform) {
      var selector = $.one("#filters #platform_" + presetPlatform);
      if (selector) {
        selector.click();
      }
    }

    updateFilterStatus();

    pymChild.sendHeight();
    window.addEventListener("resize", () => pymChild.sendHeight());
  });
}

// shuffle the programs
// via https://stackoverflow.com/questions/43979555/javascript-shuffle-divs-within-div
var shufflePrograms = function(c, el) {
  var container = document.getElementById(c);
  var elements = Array.prototype.slice.call(container.getElementsByClassName(el));
  elements.forEach(function(element){
    container.removeChild(element);
  });
  shuffleArray(elements);
  elements.forEach(function(element){
    container.appendChild(element);
  })
}

function shuffleArray(array) {
  for (var i = array.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    var temp = array[i];
    array[i] = array[j];
    array[j] = temp;
  }
  return array;
}

var filterContent = function(evt) {
  // console.log("clicked: " + evt.target.value);

  if (evt.target.checked) {
    if (!usedFilters) {
      usedFilters = true;
      ANALYTICS.trackEvent("filter-used", true);
    }
    ANALYTICS.trackEvent("filter-activated", evt.target.value); 
  }

  // handle all vs. singular toggles
  [ "genre", "platform" ].forEach((section, i) => {
    if (evt.target.value == (section + "_all") && evt.target.checked) {
      document.querySelectorAll("#filters ." + section + " input[type=checkbox]:checked").forEach((item, i) => {
        if (item.value != (section + "_all")) {
          item.checked = false;
        }
      });
    } else if (evt.target.value == (section + "_all") && !evt.target.checked) {
      // don't allow the "all" filters to become unchecked if they're the only ones
      document.querySelector("#filters #" + section + "_all").checked = true;
    } else if (evt.target.value.includes(section + "_")) {
      // untoggle "all" if you use a sub-filter
      document.querySelector("#filters #" + section + "_all").checked = false;
    }
  });

  // compile all the currently-selected filters
  var checkFilters = function(section) {
    return $(
      "#filters ." + section + " input[type=checkbox]:checked",
      filters
    ).map((el) => el.getAttribute("value"));
  }

  var genreFiltersChecked = checkFilters("genre");
  
  // if "film" filter was just checked, untoggle "tv" and "all"
  if (evt.target.value == "type_film" && document.querySelector("#filters #type_film").checked == true) {
    document.querySelector("#filters #genre_all").checked = false;
    document.querySelector("#filters #type_tv").checked = false;
    typeMode = "film";
  }
  // if "tv" filter was just checked, untoggle "film" and "all"
  if (evt.target.value == "type_tv" && document.querySelector("#filters #type_tv").checked == true) {
    document.querySelector("#filters #genre_all").checked = false;
    document.querySelector("#filters #type_film").checked = false;
    typeMode = "tv";
  }
  
  genreFiltersChecked = checkFilters("genre");

  if (document.querySelector("#filters #type_film").checked == false && document.querySelector("#filters #type_tv").checked == false) {
    typeMode = "all";
  }

  // if no filters are selected, go back to "all"
  if (genreFiltersChecked.length == 0) {
    document.querySelector("#filters #genre_all").checked = true;
    genreFiltersChecked = checkFilters("genre");
  }

  var platformFiltersChecked = checkFilters("platform");
  // if no filters are selected, go back to "all"
  if (platformFiltersChecked.length == 0) {
    document.querySelector("#filters #platform_all").checked = true;
    platformFiltersChecked = checkFilters("platform");
  }
  // console.log(genreFiltersChecked, platformFiltersChecked);

  // show/hide reviews
  var matchingReviews = 0;
  // console.log(genreFiltersChecked);
  reviews.forEach((review, i) => {
    var reviewName = review.querySelector("h3").innerHTML;

    var hasGenre = false; // matches active genre(s)
    var hasTypeMode = false; // matches all vs. film vs. tv state
    var hasPlatform = false; // matches active platform(s)
    var typeSelector = typeMode == "film" ? "type_film" : "type_tv"; // only relevant for "film" and "tv" type modes

    // match against any genre
    if (genreFiltersChecked.includes("genre_all")) {
      hasGenre = true;
    } else if (genreFiltersChecked.includes(typeSelector) && genreFiltersChecked.length == 1) {
      hasGenre = true; // needed if "film" or "tv" are the ONLY genre filters selected
    } else {
      // initially tried intersection, which worked:
      // https://github.com/you-dont-need/You-Dont-Need-Lodash-Underscore#_intersection
      // but some() seems to do the thing i need w/ less code:
      // https://stackoverflow.com/questions/16312528/check-if-an-array-contains-any-element-of-another-array-in-javascript
      hasGenre = genreFiltersChecked.some(r => [...review.classList].indexOf(r) >= 0 && r != "type_film" && r != "type_tv");
      // w/ the (r != "type_film" && r != "type_tv") -> ignoring whether it matches "film" or "tv" filters
      // here we want to know whether it matches ANY genre that's not film/tv
      // (later we'll check film/tv — that's an OR, not an AND)
    }

    // match against any platform
    if (platformFiltersChecked.includes("platform_all")) {
      hasPlatform = true;
    } else {
      hasPlatform = platformFiltersChecked.some(r => [...review.classList].indexOf(r) >= 0);
    }

    // match against film OR tv
    if (typeMode == "all") {
      hasTypeMode = true;
    } else if (typeMode == "film" && review.classList.contains("type-film")) {
      hasTypeMode = true;
    } else if (typeMode == "tv" && review.classList.contains("type-tv")) {
      hasTypeMode = true;
    }

    // if it matches all the conditions, show it
    if (hasGenre && hasTypeMode && hasPlatform) {
      review.classList.remove("hidden");
      matchingReviews++;
    } else {
      review.classList.add("hidden");
    }
  });

  updateFilterStatus(matchingReviews);

  pymChild.sendHeight();
}

var updateFilterStatus = function() {
  var activeCount = $(".review:not(.hidden)").length;
  var statusMsg = "";
  switch(activeCount) {
    case 0:
      statusMsg = "No programs found.";
      break;
    case 1:
      statusMsg = "1 program found.";
      break;
    default:
      statusMsg = activeCount + " programs found.";
      break;
  }
  filterStatus.innerHTML = statusMsg;
}

// wait for images to load
window.addEventListener("load", onWindowLoaded);
